import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { fetchConciseBranchKeyPrefix } from '../keys/configuration'

type InputArguments = {
  branchName: string
  server: ConfigurableServer
}

export const useCatchupBranch = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ branchName, server }: InputArguments) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostCatchUpBranch(
        {
          requestBody: {
            _type: 'BranchCommandSpecification',
            branchName,
            componentName: server.toLocaleLowerCase(),
          },
        },
      )
    },
    onSuccess: (_, variables) =>
      queryClient.invalidateQueries({
        queryKey: fetchConciseBranchKeyPrefix({
          server: variables.server,
          branchName: variables.branchName,
        }),
      }),
  })
}
